(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anvil-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-faq-trigger]');
    if (!trigger) return;
    var item = trigger.closest('[data-faq-item]');
    var list = trigger.closest('.anvil-faq__list');
    if (!item || !list) return;
    var wasOpen = item.classList.contains('anvil-faq__item--open');

    list.querySelectorAll('[data-faq-item]').forEach(function (el) {
      var willOpen = el === item && !wasOpen;
      el.classList.toggle('anvil-faq__item--open', willOpen);
      var t = el.querySelector('[data-faq-trigger]');
      var a = el.querySelector('.anvil-faq__answer');
      if (t) t.setAttribute('aria-expanded', String(willOpen));
      if (a) a.hidden = !willOpen;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anvil-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var scrollBtn = event.target.closest('.anvil-hero__scroll-btn');
    if (!scrollBtn) return;
    var hero = scrollBtn.closest('.anvil-hero');
    var target = hero && hero.querySelector('.anvil-hero__snapshot');
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-snapshot-form]');
    if (!form) return;
    event.preventDefault();

    var wrapper = form.closest('.anvil-hero__snapshot');
    var teaser = wrapper && wrapper.querySelector('[data-snapshot-teaser]');
    var errorEl = form.querySelector('[data-snapshot-error]');
    var submitBtn = form.querySelector('.anvil-hero__submit');
    var submitLabel = submitBtn && submitBtn.querySelector('span');
    var endpoint = wrapper && wrapper.getAttribute('data-snapshot-endpoint');
    if (!teaser || !submitBtn || !submitLabel || !endpoint) return;

    var websiteField = form.querySelector('[name="website"]');
    var emailField = form.querySelector('[name="email"]');
    var originalLabel = submitLabel.textContent;
    var loadingLabel = form.getAttribute('data-loading-label') || originalLabel;

    if (errorEl) errorEl.hidden = true;
    submitBtn.disabled = true;
    submitLabel.textContent = loadingLabel;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 15000);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
      body: JSON.stringify({
        website: websiteField ? websiteField.value : '',
        email: emailField ? emailField.value : ''
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Snapshot request failed with status ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.segment_1 || !data.segment_2) {
          throw new Error('Snapshot response was missing segment data');
        }

        var name1 = teaser.querySelector('[data-segment-1-name]');
        var problem1 = teaser.querySelector('[data-segment-1-problem]');
        var name2 = teaser.querySelector('[data-segment-2-name]');
        var body2 = teaser.querySelector('[data-segment-2-body]');

        if (name1) name1.textContent = data.segment_1.name || '';
        if (problem1) problem1.textContent = data.segment_1.problem || '';
        if (name2) name2.textContent = data.segment_2.name || '';
        if (body2) {
          if (data.segment_2.problem) {
            body2.textContent = data.segment_2.problem;
            body2.hidden = false;
          } else {
            body2.hidden = true;
          }
        }

        form.hidden = true;
        teaser.hidden = false;
      })
      .catch(function () {
        if (errorEl) errorEl.hidden = false;
      })
      .finally(function () {
        clearTimeout(timeoutId);
        submitBtn.disabled = false;
        submitLabel.textContent = originalLabel;
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anvil-intake-page"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var card = document.querySelector('.anvil-intake-page__card');
    if (!card) return;

    var missingEl = card.querySelector('[data-intake-missing]');
    var headerEl = card.querySelector('[data-intake-header]');
    var tierBadge = card.querySelector('[data-intake-tier-badge]');
    var metaEl = card.querySelector('[data-intake-meta]');
    var form = card.querySelector('[data-intake-form]');
    var silverField = card.querySelector('[data-silver-field]');
    var homepageUrlWrap = silverField ? silverField.querySelector('[data-homepage-url-wrap]') : null;
    var homepageTextWrap = silverField ? silverField.querySelector('[data-homepage-text-wrap]') : null;
    var homepageUrlInput = homepageUrlWrap ? homepageUrlWrap.querySelector('input') : null;
    var homepageTextInput = homepageTextWrap ? homepageTextWrap.querySelector('textarea') : null;
    var homepageModeInputs = silverField ? silverField.querySelectorAll('[data-homepage-mode-input]') : [];
    var loadingEl = card.querySelector('[data-intake-loading]');
    var successEl = card.querySelector('[data-intake-success]');
    var errorEl = card.querySelector('[data-intake-error]');
    var defaultErrorText = errorEl ? errorEl.textContent : '';
    var endpoint = card.getAttribute('data-intake-endpoint');

    var params = new URLSearchParams(window.location.search);
    var tier = (params.get('tier') || '').toLowerCase();
    var orderId = params.get('order_id') || '';
    var email = params.get('email') || '';
    var validTier = tier === 'bronze' || tier === 'silver';

    if (!validTier || !orderId || !email) {
      if (missingEl) missingEl.hidden = false;
      return;
    }

    if (headerEl) headerEl.hidden = false;
    if (tierBadge) {
      tierBadge.classList.add('anvil-tier-badge--' + tier);
      tierBadge.textContent = card.getAttribute('data-tier-label-' + tier) || tier;
    }
    if (metaEl) metaEl.textContent = 'Order ' + orderId + ' · ' + email;

    function setHomepageMode(mode) {
      if (homepageUrlWrap) homepageUrlWrap.hidden = mode !== 'url';
      if (homepageTextWrap) homepageTextWrap.hidden = mode !== 'text';
      if (homepageUrlInput) homepageUrlInput.required = mode === 'url';
      if (homepageTextInput) homepageTextInput.required = mode === 'text';
    }

    if (tier === 'silver' && silverField) {
      silverField.hidden = false;
      setHomepageMode('url');
      for (var m = 0; m < homepageModeInputs.length; m++) {
        homepageModeInputs[m].addEventListener('change', function (event) {
          setHomepageMode(event.target.value);
        });
      }
    }

    if (form) form.hidden = false;

    if (!form || !endpoint) return;

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var submitBtn = form.querySelector('.anvil-intake-page__submit');
      var submitLabel = submitBtn && submitBtn.querySelector('span');
      var originalLabel = submitLabel ? submitLabel.textContent : '';
      var loadingNote = form.getAttribute('data-loading-note');

      var answers = [];
      for (var i = 1; i <= 9; i++) {
        var field = form.querySelector('[name="q' + i + '"]');
        answers.push(field ? field.value : '');
      }

      var payload = {
        tier: tier,
        order_id: orderId,
        email: email,
        answers: answers
      };
      if (tier === 'silver') {
        if (homepageUrlWrap && !homepageUrlWrap.hidden) {
          payload.homepage_url = homepageUrlInput.value;
        } else if (homepageTextWrap && !homepageTextWrap.hidden) {
          payload.homepage_text = homepageTextInput.value;
        }
      }

      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = defaultErrorText;
      }
      if (submitBtn) submitBtn.disabled = true;
      if (submitLabel && loadingNote) submitLabel.textContent = loadingNote;
      form.hidden = true;
      if (loadingEl) loadingEl.hidden = false;

      var controller = new AbortController();
      var timeoutId = setTimeout(function () { controller.abort(); }, 180000);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        signal: controller.signal,
        body: JSON.stringify(payload)
      })
        .then(function (response) {
          return response.json().catch(function () { return {}; }).then(function (data) {
            if (!response.ok) {
              var message = data && data.error ? data.error : null;
              throw new Error(message || ('Intake request failed with status ' + response.status));
            }
            return data;
          });
        })
        .then(function (data) {
          if (!data || !data.deliverable_pptx_base64) {
            throw new Error('Intake response was missing the deliverable');
          }

          var frameEl = successEl.querySelector('[data-intake-frame]');
          var downloadEl = successEl.querySelector('[data-intake-download]');

          if (frameEl) {
            if (data.deliverable_html) {
              var previewBlob = new Blob([data.deliverable_html], { type: 'text/html' });
              frameEl.src = URL.createObjectURL(previewBlob);
              frameEl.hidden = false;
            } else {
              frameEl.hidden = true;
            }
          }

          if (downloadEl) {
            var bytes = Uint8Array.from(atob(data.deliverable_pptx_base64), function (c) { return c.charCodeAt(0); });
            var pptxBlob = new Blob([bytes], {
              type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
            });
            downloadEl.href = URL.createObjectURL(pptxBlob);
            downloadEl.download = data.deliverable_filename || 'anvil-strategy.pptx';
          }

          if (loadingEl) loadingEl.hidden = true;
          if (successEl) successEl.hidden = false;
        })
        .catch(function (err) {
          if (loadingEl) loadingEl.hidden = true;
          form.hidden = false;
          if (errorEl) {
            errorEl.textContent = (err && err.message) || defaultErrorText;
            errorEl.hidden = false;
          }
        })
        .finally(function () {
          clearTimeout(timeoutId);
          if (submitBtn) submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = originalLabel;
        });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anvil-process"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var tab = event.target.closest('[data-process-tab]');
    if (!tab) return;
    var wrapper = tab.closest('.anvil-process');
    if (!wrapper) return;
    var tier = tab.getAttribute('data-process-tab');

    wrapper.querySelectorAll('[data-process-tab]').forEach(function (t) {
      t.classList.toggle('anvil-process__tab--active', t === tab);
    });
    wrapper.querySelectorAll('[data-process-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-process-panel') !== tier;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anvil-snapshot-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-snapshot-form]');
    if (!form) return;
    event.preventDefault();

    var card = form.closest('.anvil-snapshot-page__card');
    var teaser = card && card.querySelector('[data-snapshot-teaser]');
    var errorEl = form.querySelector('[data-snapshot-error]');
    var submitBtn = form.querySelector('.anvil-snapshot-page__submit');
    var submitLabel = submitBtn && submitBtn.querySelector('span');
    var endpoint = card && card.getAttribute('data-snapshot-endpoint');
    if (!teaser || !submitBtn || !submitLabel || !endpoint) return;

    var websiteField = form.querySelector('[name="website"]');
    var emailField = form.querySelector('[name="email"]');
    var originalLabel = submitLabel.textContent;
    var loadingLabel = form.getAttribute('data-loading-label') || originalLabel;

    if (errorEl) errorEl.hidden = true;
    submitBtn.disabled = true;
    submitLabel.textContent = loadingLabel;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 15000);

    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      signal: controller.signal,
      body: JSON.stringify({
        website: websiteField ? websiteField.value : '',
        email: emailField ? emailField.value : ''
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Snapshot request failed with status ' + response.status);
        return response.json();
      })
      .then(function (data) {
        if (!data || !data.segment_1 || !data.segment_2) {
          throw new Error('Snapshot response was missing segment data');
        }

        var name1 = teaser.querySelector('[data-segment-1-name]');
        var problem1 = teaser.querySelector('[data-segment-1-problem]');
        var name2 = teaser.querySelector('[data-segment-2-name]');
        var body2 = teaser.querySelector('[data-segment-2-body]');

        if (name1) name1.textContent = data.segment_1.name || '';
        if (problem1) problem1.textContent = data.segment_1.problem || '';
        if (name2) name2.textContent = data.segment_2.name || '';
        if (body2) {
          if (data.segment_2.problem) {
            body2.textContent = data.segment_2.problem;
            body2.hidden = false;
          } else {
            body2.hidden = true;
          }
        }

        form.hidden = true;
        teaser.hidden = false;
      })
      .catch(function () {
        if (errorEl) errorEl.hidden = false;
      })
      .finally(function () {
        clearTimeout(timeoutId);
        submitBtn.disabled = false;
        submitLabel.textContent = originalLabel;
      });
  });

  } catch(e) { console.error(e); }
})();
})();
